import { Component, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router, ActivatedRoute, RouterEvent } from '@angular/router';
import { NAV_ROUTE } from './nav-route';
import { AuthService } from '../../services/auth/auth.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-nav',
  templateUrl: './app-nav.component.html',
  styleUrls: ['./app-nav.component.css']
})
export class MyNavComponent implements OnDestroy {
  routeTitle: string = '';
  nav_router: Array<any> = [];
  sub_Menu: Array<any> = [];
  numberAlert: number;
  subscription: Subscription;
  login: string;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(private breakpointObserver: BreakpointObserver,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private snackBar: MatSnackBar) {
    this.login = localStorage.getItem('login');
    router.events.subscribe((val: RouterEvent) => {
      for (let i = 0; i < NAV_ROUTE.length; i++) {
        if (NAV_ROUTE[i].routeLink === val.url) {
          this.routeTitle = NAV_ROUTE[i].routeTitle;
          localStorage.setItem('activeWindow', this.routeTitle);
        } else if (NAV_ROUTE[i].routeLink === '') {
          for (let j = 0; j < NAV_ROUTE[i].submenu.length; j++) {
            if (NAV_ROUTE[i].submenu[j].routeLink === val.url) {
              this.routeTitle = NAV_ROUTE[i].submenu[j].routeTitle;
              localStorage.setItem('activeWindow', this.routeTitle);
            }
          }
        }
      }
    });
    this.nav_router = NAV_ROUTE;

  }

  ngOnDestroy(): void {
    this.authService.closeChangePass();
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['login']);
  }

  isMatIcon(icon: string) {
    if (icon.startsWith('bw_')) {
      return false;
    }
    return true;
  }
  getIconPath(icon: string) {
    return './assets/img/icon/' + icon.split('bw_')[1] + '.svg';
  }

  openHistoryAlerts() {}
}

